import type { LoadingSpinnerModel } from "../../type/spinner";
import { useI18n } from "../../utils/translate/i18n/useI18n";
import "./loadingSpinner.scss";



export default function LoadingSpinner({
  label = "Ładowanie…",
  className
}: LoadingSpinnerModel) {
  const { t } = useI18n();
  const classes = ["loading-spinner", className].filter(Boolean).join(" ");

  return (
    <div className={classes}>
      <div className="spinner-border spinner-border-sm me-2" role="status" />
      {t(label)}
    </div>
  );
}